// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   Button,
//   Badge,
//   Popover,
//   ScrollShadow,
//   PopoverContent,
//   PopoverTrigger,
// } from "@nextui-org/react";
// import { BiBell } from "react-icons/bi";
// import { io } from "socket.io-client";
// import { formatTime } from "../utils";
// import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

// import {
//   setNotifications,
//   setAllNotifications,
//   addNotification,
//   deleteNotification as deleteNotifFromStore,
//   setAdminNotifications,
//   addAdminNotification,
//   deleteAdminNotification,
// } from "../store/slices/notificationSlice";

// const roleLink = {
//   QUOTE: "/updateStatus/",
//   QUOTES: "/accept-order/",
//   DISPUTE: "/support/",
//   ORDER: "/orders/",
//   COMMENT: "/requests/",
//   NEW_COMMENT: "/requests/",
//   REQUEST: "/requests/",
//   NEWUSER: "/updateprofile/",
//   NEWREQUEST: "/requestDetails/",
//   Request: "/requestDetails/",
//   REPLY: "/requests/",
// };
// const Notification = () => {
//   const dispatch = useDispatch();
// const [adminSocket, setAdminSocket] = useState(null); // for admin
//   const accessToken = localStorage.getItem("accessToken");
//   const role = localStorage.getItem("role");
//   const { user } = useSelector((state) => state.auth);
//   const notifications = useSelector(
//     (state) => state.notification.notifications
//   );
//   //
//   const adminNotifications = useSelector(
//     (state) => state.notification.adminNotifications
//   );

//   // console.log("🧾 Admin notifications from store:", adminNotifications);
//    const displayNotifications =
//     role === "ADMIN" ? adminNotifications : notifications;

//   // console.log("------------------------------- ", displayNotifications);

//   const navigate = useNavigate();
//   const isAdmin = role === "ADMIN";

//   // console.log("🔔 Current Notifications:", notifications);
//   const allNotifications = useSelector(
//     (state) => state.notification.allNotifications
//   );
//   // console.log(allNotifications, "All Notifications");

//   const [socket, setSocket] = useState(null);
//   const [isNotificationOpen, setIsNotificationOpen] = useState(false);

//   const handleClick = (notifId, path) => {
//     setIsNotificationOpen(false);
//     // if (role !== "ADMIN" && path) {
//     //   navigate(path);
//     // }
//     if (path) {
//       navigate(path);
//     }
//     if (!socket) return;

//     socket.off("deleteNotificationSuccess");
//     socket.off("deleteNotificationNotFound");
//     socket.off("deleteNotificationError");

//     if (role === "ADMIN") {
//       // Just remove from Redux store — no backend/socket
//        console.log("🖱️ ADMIN click: trying to delete ID", notifId);
// console.log("🔊 Emitting from socket:", adminSocket.id); // Add this
//        adminSocket.emit("delete-admin-notification",  notifId); // NEW
//       dispatch(deleteAdminNotification(notifId));

//       return;
//     }

//     socket.on("deleteNotificationSuccess", (message) => {
//       dispatch(deleteNotifFromStore(message.messageId));
//       console.log("🗑️ Deleted notification ID:", message.messageId);
//     });

//     socket.on("deleteNotificationNotFound", (message) => {
//       console.warn("❓ Notification not found:", message);
//     });

//     socket.on("deleteNotificationError", (message) => {
//       console.error("❌ Error deleting notification:", message);
//     });

//     if (!socket) return;
//     socket.emit("delete notification", { id: notifId });
//   };

//   useEffect(() => {
//     if (user?.id && accessToken) {
//       const newSocket = io(
//         `${process.env.REACT_APP_SOCKET_SERVER_URL}/notifications/${user.id}/${role}`,
//         {
//           extraHeaders: {
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );

//       console.log(
//         "Listening to topic:",
//         `notifications_prod_${user.id}_${role}`
//       );
//       setSocket(newSocket);

//       newSocket.on("previous notification", (notificationList) => {
//         dispatch(setNotifications(notificationList));
//         dispatch(setAllNotifications(notificationList));
//         // console.log("Previous notifications:", notificationList);
//       });

//       newSocket.on("notification", (notification) => {
//         // if (notification.user_role !== role) return;
//         if (role !== "ADMIN" && notification.user_id !== user.id) return;
//         // console.log("🔔  Notification payload:--->>>>>", notification);
//         // console.log("🔔  Role payload:--->>>>>", role);
//         // console.log("UserRole", notification.user_id);

//         // console.log(
//         //   "user_role --------➜",
//         //   notification?.user_role ?? "undefined"
//         // );
//         setTimeout(() => {
//           dispatch(addNotification(notification));

//           // console.log("📨 New notification received:", notification);
//         }, 1000);
//       });

//       return () => {
//         newSocket.disconnect();
//       };
//     }
//   }, [user?.id, accessToken, role, dispatch]);

//   useEffect(() => {
//     if (role === "ADMIN" && accessToken) {
//       const adminSocket = io(
//         `${process.env.REACT_APP_SOCKET_SERVER_URL}/admin/notification`,
//         {
//           extraHeaders: {
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );
//        setAdminSocket(adminSocket);
//       adminSocket.on("connect", () => {
//         // console.log("✅ Connected to /admin socket");
//       });

//       adminSocket.on("previous-admin-notification", (adminNotificationList) => {
//         // console.log("📜 Previous Admin Notifications:", adminNotificationList);
//         dispatch(setAdminNotifications(adminNotificationList));
//       });

//       adminSocket.on("admin-notification", (data) => {
//         // console.log("📢 Admin Notification Received:", data);
//         const notification = data?.data ?? data; // ✅ unwrap "data" if wrapped

//         // console.log("📢 Admin Notification Unwrapped:", notification);

//         //   dispatch(addAdminNotification(notification));

//         dispatch((dispatch, getState) => {
//           const existing = getState().notification.adminNotifications;
//           const alreadyExists = existing.some((n) => n.id === notification.id);
//           if (!alreadyExists) {
//             dispatch(addAdminNotification(notification));
//           }
//         });
//       });
// adminSocket.on("admin-notification-deleted", ({ success, id, error }) => {
//   if (success) {
//     console.log("🧹 Admin notification deleted:", id);
//     dispatch(deleteAdminNotification(id)); // Optional if already done on click
//   } else {
//     console.error("❌ Failed to delete admin notification:", error);
//   }
// });

//       adminSocket.on("disconnect", () => {
//         // console.log("🔌 Admin socket disconnected");
//       });

//       return () => {
//         adminSocket.disconnect();
//       };
//     }
//   }, [role, accessToken, dispatch]);

//   return (
//     <Popover
//       shouldBlockScroll
//       triggerType="listbox"
//       isOpen={isNotificationOpen}
//       onOpenChange={(open) => setIsNotificationOpen(open)}
//     >
//      <Badge
//   content={
//     displayNotifications.length > 0
//       ? displayNotifications.length >= 100
//         ? "100+"
//         : displayNotifications.length
//       : null
//   }
//   className="bg-red-500 text-white"
// >

//         <PopoverTrigger>
//           <Button
//             isIconOnly
//             variant="light"
//             disableRipple
//             disableAnimation
//             className="border-1 rounded-full border-gray-400"
//           >
//             <BiBell className="text-xl" />
//           </Button>
//         </PopoverTrigger>
//       </Badge>

//       <PopoverContent className="p-2">
//         <ScrollShadow hideScrollBar className="w-48 max-h-52">
//           {/* {notifications.length ? (
//             notifications.map((item) => { */}
//           {displayNotifications.length ? (
//             displayNotifications.map((item) => {
//               // const basePath = roleLink[item.group] || "/";
//               // const fullPath = `${basePath}${item.related_id}`;
//               const cleanId = String(item.related_id).replace(/"/g, "");
//               const basePath = roleLink[item.group] || "/";
//               const fullPath = `${basePath}${cleanId}`;
//               const content = (
//                 <>
//                   <p className="text-[0.8rem] font-semibold">{item.message}</p>
//                   <p className="text-default-400 text-[0.7rem]">
//                     {formatTime(item.createdAt)}
//                   </p>
//                 </>
//               );
//               return (
//                 <div
//                   key={item.id}
//                   className="p-2 rounded-lg cursor-pointer hover:bg-default-100"
//                   onClick={
//                     () =>
//                       // handleClick(item.id)}
//                       handleClick(item.id, fullPath)

//                     //handleClick(item.id, isAdmin ? null : fullPath)
//                   }
//                 >
//                   <Link to={fullPath}>{content}</Link>
//                   {/* {content} */}
//                 </div>
//               );
//             })
//           ) : (
//             <p className="p-3 text-sm text-center">No new notifications</p>
//           )}
//         </ScrollShadow>
//       </PopoverContent>
//     </Popover>
//   );
// };

// export default Notification;

import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Badge,
  Popover,
  ScrollShadow,
  PopoverContent,
  PopoverTrigger,
} from "@nextui-org/react";
import { BiBell } from "react-icons/bi";
import { formatTime } from "../utils";
import { Link, useNavigate } from "react-router-dom";

/*  NEW: apna custom hook  */
//import useNotificationSocket from "../hooks/useNotificationSocket";

import {
  deleteNotification as deleteNotifFromStore,
  deleteAdminNotification,
} from "../store/slices/notificationSlice";

/* --- baaki mapping / constants wahi purane --- */
const roleLink = {
  QUOTE: "/updateStatus/",
  QUOTES: "/accept-order/",
  DISPUTE: "/support/",
  ORDER: "/orders/",
  COMMENT: "/requests/",
  NEW_COMMENT: "/requests/",
  REQUEST: "/requests/",
  NEWUSER: "/updateprofile/",
  NEWREQUEST: "/requestDetails/",
  Request: "/requestDetails/",
  REPLY: "/requests/",
  COMMENT_REPORT: "/requestDetails/",
};

const Notification = ({ emitDelete }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /*  NEW: socket helper */
  //const { emitDelete } = useNotificationSocket();

  const role = localStorage.getItem("role");
  const isAdmin = role === "ADMIN";
  const notifications = useSelector((s) => s.notification.notifications);
  const adminNotifications = useSelector(
    (s) => s.notification.adminNotifications
  );
  const displayNotifications = isAdmin ? adminNotifications : notifications;

  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (id, path) => {
    setIsOpen(false);
    if (path) navigate(path);

    if (isAdmin) {
      dispatch(deleteAdminNotification(id));
    } else {
      dispatch(deleteNotifFromStore(id));
    }

    emitDelete(id, isAdmin);
  };

  return (
    <Popover
      shouldBlockScroll
      triggerType="listbox"
      isOpen={isOpen}
      onOpenChange={setIsOpen}
    >
      <Badge
        content={
          displayNotifications.length >= 100
            ? "100+"
            : displayNotifications.length || null
        }
        className="bg-red-500 text-white"
      >
        <PopoverTrigger>
          <Button
            isIconOnly
            variant="light"
            disableRipple
            disableAnimation
            className="border-1 rounded-full border-gray-400"
          >
            <BiBell className="text-xl" />
          </Button>
        </PopoverTrigger>
      </Badge>

      <PopoverContent className="p-2">
        <ScrollShadow hideScrollBar className="w-48 max-h-52">
          {displayNotifications.length ? (
            displayNotifications.map((item) => {
              const cleanId = String(item.related_id).replace(/"/g, "");
              const basePath = roleLink[item.group] || "/";
              const fullPath = `${basePath}${cleanId}`;

              return (
                <div
                  key={item.id}
                  className="p-2 rounded-lg cursor-pointer hover:bg-default-100"
                  onClick={() => handleClick(item.id, fullPath)}
                >
                  <Link to={fullPath}>
                    <p className="text-[0.8rem] font-semibold">
                      {item.message}
                    </p>
                    <p className="text-default-400 text-[0.7rem]">
                      {formatTime(item.createdAt)}
                    </p>
                  </Link>
                </div>
              );
            })
          ) : (
            <p className="p-3 text-sm text-center">No new notifications</p>
          )}
        </ScrollShadow>
      </PopoverContent>
    </Popover>
  );
};

export default Notification;
